export default "__VITE_ASSET__c06121f6__"